import {AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {MarmosetAsset} from '@app/asset';
import {ViewerToolsService} from '@app/viewer/viewer-tools.service';
import {MarmosetService} from '../marmoset.service';
import {IViewable, ViewerTool} from '../viewable.interface';

@Component({
    selector: 'frog-marmoset',
    templateUrl: './marmoset.component.html',
    styleUrls: ['./marmoset.component.scss'],
    standalone: true,
})
export class MarmosetComponent implements OnInit, OnDestroy, AfterViewChecked, IViewable {
    @Input() asset: MarmosetAsset;
    private fullscreenElement: HTMLInputElement;
    private layersElement: HTMLInputElement;

    constructor(
        private marmosetService: MarmosetService,
        private viewerToolsService: ViewerToolsService,
        private element: ElementRef,
    ) {
        this.fullscreenElement = null;
        this.layersElement = null;
    }

    ngOnInit(): void {
        this.marmosetService.load(this.asset.source);
        this.marmosetService.ready.subscribe((viewerElement) => {
            this.element.nativeElement.appendChild(viewerElement);
        });

        this.viewerToolsService.setTools([]);
    }

    ngOnDestroy() {
        this.marmosetService.hide();
    }

    ngAfterViewChecked() {
        if (this.fullscreenElement === null || this.layersElement === null) {
            this.fullscreenElement =
                document.querySelector('#marmosetUI input[title="Full Screen"]') || null;
            this.layersElement =
                document.querySelector('#marmosetUI input[title="Layer Views"]') || null;

            if (this.fullscreenElement !== null && this.layersElement !== null) {
                // Both buttons are available, so let the viewer knwo about the tools
                const viewerTools = [
                    new ViewerTool({
                        icon: 'branding_watermark',
                        tooltip: 'Fullscreen',
                        action: () => {
                            this.fullscreenElement.onclick(null);
                        },
                    }),
                    new ViewerTool({
                        icon: 'layers',
                        tooltip: 'Layer Views',
                        action: () => {
                            this.layersElement.onclick(null);
                        },
                    }),
                ];

                // We hide the default marmoset tools since we are providing access with our own tools
                document
                    .querySelector('#marmosetUI > div:last-child')
                    .setAttribute('hidden', 'hidden');

                this.viewerToolsService.setTools(viewerTools);
            }
        }
    }

    center(): void {}

    scaleToSource(): void {}

    scaleToWindow(): void {}
}
